// ============================================
// Sector Models - BinnaclePro
// Similar a AWS Regions - Manejo de sectores globalmente
// ============================================

/**
 * Representa un sector/ubicación en el sistema
 * Similar a una "región" en AWS
 */
export interface Sector {
  id: number;
  name: string;
}

/**
 * Valor especial para "Todos los sectores" (Global)
 */
export const GLOBAL_SECTOR: Sector = {
  id: 0,
  name: 'Global'
};

/**
 * Configuración del almacenamiento de sector
 */
export const SECTOR_STORAGE_KEY = 'selected_sector';
